<template>
  <div class="vue-wrapper-sidebar">
    <div class="modal-window-header">
      <div class="modal-window-heading">
        <h3>Kontrakthistorikk</h3>
      </div>
    </div>

    <overlay-scrollbars v-if="!loading && items.length > 0" :options="{ className: 'modal-window-body gray os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <table class="small clickable" v-if="!loading && items.length > 0">
        <tr v-for="item in filteredItems" v-bind:key="item.Brukerloggid">
          <td>
            <a href="javascript:;" class="data-modal" @click="openHistoryModal(item)">
              <span class="avatar name right" :class="strToAvatarClass(item.bruker.initials)" v-if="item.bruker">
                {{item.bruker.initials}}
                <span class="name">{{item.bruker.full_name}}</span>
              </span>
              <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
                -
                <span class="name">Ikke tilgjengelig</span>
              </span>

              <span class="title-container" v-if="item.Tabell === 'KontraktPDF'">
                <span class="title">Kontrakt sendt</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
              <span class="title-container" v-else-if="item.Tabell === 'KvitteringPDF'">
                <span class="title">Kvittering sendt</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
              <span class="title-container" v-else>
                <span class="title" v-if="item.Endring === 'ukInsert'">Kontrakt opprettet</span>
                <span class="title" v-if="item.Endring === 'ukModify'">Kontrakt endret</span>
                <span class="title" v-if="item.Endring === 'ukDelete'">Kontrakt slettet</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
            </a>
          </td>
        </tr>
        <tr>
          <td style="text-align: center" colspan="2" v-if="!everythingLoaded && pageCount > 1">
            <div style="margin-top: 10px">
              <button href="javascript:;" @click="loadMore()" class="button secondary action glyph" v-if="!loading && !updating">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Last fler</span>
              </button>
              <button href="javascript:;" class="button secondary action glyph loading" v-else>
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
            </div>
          </td>
          <td style="text-align: center" colspan="2" v-if="everythingLoaded || pageCount <= 1">
            <div style="margin-top: 10px">
              Alt har blitt lastet inn
            </div>
          </td>
        </tr>
      </table>

      <div class="expandable-search" :class="{'active': searchBoxActive, 'search-active': search != ''}" v-if="!loading && items.length > 0">
        <div class="input-container search no-margin comment">
          <input  class="rounded" type="text" placeholder="Søk i historikk…" v-model="search" v-on:keydown="onSearchInput" v-on:blur="toggleSearchbox(false)" v-on:focus="toggleSearchbox(true)">
          <button class="glyph-button" type="submit">Søk <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
          <a href="javascript:;" @click="clearSearch()" class="cancel-search"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
        </div>
      </div>
    </overlay-scrollbars>

    <div v-else class="modal-window-body gray">
      <TheLoader :active="loading"/>
      <TheEmptyList v-if="!loading && items.length < 1" :title="'Ingen historikk'" :message="''" :large="false" :icon="'button-glyph-history'"/>
    </div>

    <a href="javascript:;" @click="closeModal()" class="modal-close modal-window-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KundeKontraktSidebarHistorikk',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      search: '',
      searchBoxActive: false,
      skipLogKeys: [
        'kundeadresse',
        'Sist_endret_av',
        'Sist_endret_tid',
        'Hbversion'
      ]
    }
  },
  created: function () {
    // Not in use, as we removed paging
    this.currentPage = this.queryParams.page || 1

    // Debounced input
    this.onSearchInput = this._.debounce(this.onSearchInput, 500)

    if (this.$store.getters['kontrakthistory/needreload']) {
      this.$store.dispatch('kontrakthistory/load', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr
      })
    }
  },
  computed: {
    ...mapGetters('kontrakthistory', [
      'items',
      'pageCount',
      'totalCount',
      'everythingLoaded',
      'queryParams',
      'loading',
      'updating'
    ]),
    filteredItems: function () {
      if (!this.search) {
        return this.items
      }

      return this.items.filter((i) => {
        return this._.includes(this._.toLower(i.Logg), this.search)
      })
    }
  },
  methods: {
    openHistoryModal: function (item) {
      if (item.Tabell === 'KontraktPDF' || item.Tabell === 'KvitteringPDF') {
        this.openModal(
          'history-item-kontrakt-pdf-modal',
          {
            kontrakt: this.kontrakt,
            item: item,
            internalWindow: true
          },
          'split'
        )
      } else {
        this.openModal(
          'history-item-modal',
          {
            item: item
          }
        )
      }
    },
    clearSearch: function () {
      this.search = ''
      this.toggleSearchbox(false)
    },
    toggleSearchbox: function (mode) {
      if (mode === false) {
        this.searchBoxActive = this.search !== ''
      } else {
        this.searchBoxActive = true
      }
    },
    onSearchInput: function (e) {
      // In it's own method, so we can have debounce
      this.search = this._.toLower(e.target.value.trim())
    },
    loadMore: function () {
      let page = this.currentPage + 1

      if (page > this.pageCount) {
        console.log('Last page already loaded')
        return
      }

      // Make query to load more...
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('kontrakthistory/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        queryParams: copiedParams
      }).then((response) => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktSidebarHistorikk.vue